
export const REDIRECT_KEY = 'next_page';

export function setItem(key, value) {
  localStorage.setItem(key, value);
}

export function getItem(key) {
  return localStorage.getItem(key);
}

export function removeItem(key) {
  localStorage.removeItem(key);
}

export function getLocalStorageController(key) {
  return {
    setItem: (value) => setItem(key, value),
    getItem: () => getItem(key),
    removeItem: () => removeItem(key),
  }
}